 export const skillsData = [
    'HTML',
    'Javascript',
    'CSS',
     'React',
     "Bootstrap",
     "MongoDB",
     "nodejs",
    "ExpressJS"
]

